<script setup lang="ts">
/**
 * Root-Component. Inhalt kommt vom Router — entweder Login-Page oder
 * der Dashboard-Layout mit eingeschachtelten Views. ToastStack ist
 * global und rendert über Teleport ins document.body.
 */
import ToastStack from '@/components/ToastStack.vue';
</script>

<template>
  <router-view />
  <ToastStack />
</template>
